import { Component } from '@angular/core';
import { TipoConteudo as TipoConteudo, TipoConsultaImpedimento } from '../../../model/arquivo.model';


@Component({
  selector: 'app-importacao-pesquisar-ipd',
  templateUrl: './importacao-pesquisar-ipd.component.html',
    standalone: false
})
export class ImportacaoPesquisarIpdComponent {

  textoBotaoEnvio = 'Enviar lote importação IPD';
  tooltipBotaoEnvio = 'Selecione esta opção para enviar um arquivo com CNPJ, ';
  tipoConsultaImpedimento: TipoConsultaImpedimento[] = [
    TipoConsultaImpedimento.IMPORTACAO_CERTIDAO_CADIN
  ];
}
